"use strict";
const numeral = require('numeral');
const dayjs = require('dayjs');
const isNaN = require('lodash/isNaN');
const isNil = require('lodash/isNil');
const includes = require('lodash/includes');
const loggerService = require('../services/logService');
const { isValidEmail } = require('../email');
const { formatCurrency } = require('../formatting');
const { ATTRIBUTE_TYPE, FIELD_TYPE, FIELD_NAME, FORMAT } = require('../utils/attributesConst');
const getDisplayType = (type, displayType, format) => {
    const isPercent = includes(format, '%');
    const isCurrency = !isPercent && (includes(format, '$') || displayType?.toLowerCase() === ATTRIBUTE_TYPE.CURRENCY);
    return isCurrency ? ATTRIBUTE_TYPE.CURRENCY : type;
};
const fieldIsAttribute = (field) => (includes([ATTRIBUTE_TYPE.DATA_ATTRIBUTE, ATTRIBUTE_TYPE.STRING_ATTRIBUTE, ATTRIBUTE_TYPE.NUMBER_ATTRIBUTE, ATTRIBUTE_TYPE.SIMPLE_DATE_ATTRIBUTE], field.type));
const formatValue = ({ type, val, format, formatSettings, logger }) => {
    switch (type && type.toLowerCase()) {
        case ATTRIBUTE_TYPE.DATA_ATTRIBUTE:
        case ATTRIBUTE_TYPE.SIMPLE_DATE_ATTRIBUTE:
        case ATTRIBUTE_TYPE.DATE: {
            const dateFormat = format || FORMAT.DEFAULT_BASE_DATE_FORMAT;
            try {
                const isTimeStamp = !!parseInt(val, 10);
                if (isTimeStamp) {
                    const value = parseInt(val, 10);
                    return dayjs(value).format(dateFormat);
                }
            }
            catch (err) {
                logger.error('Utils.CustomFields: formatValue - Unable to format date attribute', {}, err, { val });
                return val;
            }
            return val;
        }
        case ATTRIBUTE_TYPE.STRING_ATTRIBUTE:
        case ATTRIBUTE_TYPE.STRING:
            return val;
        case ATTRIBUTE_TYPE.NUMBER:
            if (!(typeof val === 'number')) {
                return '--';
            }
        // falls through
        case ATTRIBUTE_TYPE.NUMBER_ATTRIBUTE:
            try {
                const numberFormat = format || FORMAT.DEFAULT_NUMBER_FORMAT;
                const formatted = numeral(val).format(numberFormat);
                return formatted;
            }
            catch (err) {
                logger.error('Utils.CustomFields: formatValue - Unable to format number attribute value', {}, err, { val });
                return val;
            }
        case ATTRIBUTE_TYPE.CURRENCY:
            return isNaN((Number(val))) ? val : formatCurrency(val, formatSettings, false);
        default:
            return undefined;
    }
};
const resolveCustomFieldValues = ({ customFields, user, type, logger = loggerService }) => {
    /* eslint-disable no-param-reassign */
    const fallbacks = customFields.fallBacks;
    const isAccountFields = type === FIELD_TYPE.ACCOUNT;
    const fields = isAccountFields ? customFields.account_fields : customFields.custom_fields;
    fields?.forEach((fieldObj, i) => {
        let sanitizedFieldName = '';
        const prefixName = fieldObj.attribute || (fieldObj._extra ? fieldObj._extra.field_name : '');
        if (prefixName) {
            sanitizedFieldName = prefixName.replace(/\s+/g, '_').replace(/[^a-z0-9_]/gi, '');
        }
        const field = `${sanitizedFieldName}_${fieldObj.index}`;
        let fallback;
        if (fieldObj?._extra?.field_name === FIELD_NAME.CUSTOM_METRICS) {
            fallback = 0; // In case that the field type is metric, its fallback should be always 0.
        }
        else {
            fallback = null;
        }
        const fieldUid = fieldObj?._extra?.uid;
        if (fallbacks && (fallbacks[field] || fallbacks[fieldUid])) {
            fallback = fallbacks[field] || fallbacks[fieldUid];
        }
        const fieldValue = isAccountFields ? user.account.selected_fields[i] : user.selected_fields[i];
        fieldObj.value = fieldValue;
        if (fieldObj.type === ATTRIBUTE_TYPE.OWNER && fieldValue && !isValidEmail(fieldValue.owner_tid_value)) {
            const ownerEmail = user.account[fieldObj.field_display_name];
            fieldObj.value = { ...fieldValue, owner_tid_value: ownerEmail, owner_user_email: ownerEmail };
        }
        let result = !isNil(fieldValue) ? fieldValue : fallback;
        if (!isNil(result)) {
            const format = fieldObj?._extra?.format_pattern;
            const fieldType = fieldIsAttribute(fieldObj) ? fieldObj.type : fieldObj?._extra?.format_type;
            const displayType = getDisplayType(fieldType, fieldObj.displayType, format);
            if (displayType) {
                result = formatValue({ type: displayType, val: result, format, formatSettings: fieldObj?.formatSettings, logger });
            }
            if (isAccountFields) {
                user.account[field] = result;
            }
            else {
                user.custom_fields[field] = result;
            }
        }
    });
};
module.exports = {
    resolveCustomFieldValues,
};
//# sourceMappingURL=index.js.map